<template>
  <div class="col-12 px-0">
    <div class="form-group pt-3 pb-5 mb-4 border-bottom">
      <label>Newsletter Type</label>
      <multiselect
        :value="newsletterType"
        :options="newsletterTypes"
        :allow-empty="false"
        :searchable="true"
        :show-labels="false"
        :class="{
          'is-invalid': ((error && error.errors.newletter_type) ? error.errors.newletter_type : []).length > 0
        }"
        @select="onSelect"
        placeholder="Select a newsletter type"
        track-by="id"
        label="name"
      />
    </div>
  </div>
</template>

<script>
import Steps from '../steps'

export default {
  props: {
    draft: {
      type: Object,
      required: true,
    },
    newsletterTypes: {
      type: Array,
      required: true,
    },
    initialValue: {
      type: Object,
      required: false,
      default: () => null
    },
  },

  data () {
    return {
      newsletterType: this.newsletterTypes.find((t) => t.id === this.draft.newsletterTypeId),
      error: null,
    }
  },

  mounted() {
    if (this.initialValue) {
      this.onSelect(this.initialValue)
    }
  },

  methods: {
    onSelect (option) {
      if (!this.draft.articleDraftId || window.confirm('The existing data will be cleared. Are you sure you want to continue?')) {
        /* eslint-disable camelcase */
        const newsletterTypeId = option.id
        const {newsletterDraftId, subject} = this.draft
        /* eslint-enable */
        const stepsKeys = this.getSteps(option.slug).map((s) => s.name).filter((k) => k !== 'preview')

        const newDraft = {
          subject,
          newsletterDraftId,
          newsletterTypeId,
          sections: [],
          tags: [],
          companies: [],
          analysts: [],
          steps: {},
        }

        stepsKeys.forEach((step) => {
          newDraft.steps[step] = {}
        })

        this.$emit('clearedDraft', newDraft)
      }
    },
    getSteps (newsletterType) {
      try {
        const steps = Steps[newsletterType]

        if (steps) {
          return steps
        } else {
          return Steps.default
        }
      } catch (_) {
        return Steps.default
      }
    },
  },
}
</script>
